const PAGINATION_DEFAULTS = {
    /*
     https://ant.design/components/pagination/

     total: number;
     defaultCurrent?: number;
     current?: number;
     defaultPageSize?: number;
     pageSize?: number;
     onChange?: (page: number, pageSize: number) => void;
     showSizeChanger?: boolean;
     pageSizeOptions?: string[];
     onShowSizeChange?: (current: number, size: number) => void;
     showQuickJumper?: boolean;
     showTotal?: (total: number) => React.ReactNode;
     size?: string;
     simple?: boolean;
     style?: React.CSSProperties;
     locale?: Object;
     className?: string;
     prefixCls?: string;
     selectPrefixCls?: string;
     */
    "showTotal": (total, range) => `${range[0]}-${range[1]} of ${total}`,
    "size": "middle", // size of buttons - can be medium or small
    "showQuickJumper": false, // Shows a GoTo text field in pagination to quickly go to a page
    "showSizeChanger": true,
    "showLessItems": window.innerWidth < 800, // On small screens show less page buttons so they don't wrap
    "defaultPageSize": 25,
    "pageSizeOptions": ["10", "25", "50", "75", "100"]
};
export default PAGINATION_DEFAULTS;
